import * as t from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/ListStar.es.js";
const o = t.forwardRef((r, a) => /* @__PURE__ */ t.createElement(e, { ref: a, ...r, weights: s }));
o.displayName = "ListStarIcon";
const c = o;
export {
  c as ListStar,
  o as ListStarIcon
};
